/**
 * Card identity.
 *
 * A card is a string literal — '10H', '14S', 'JOKER' — not an object. Hands are
 * plain `CardId[]`, structural equality is `===`, Sets and JSON are trivial, and
 * the template-literal type still gives exhaustive typing. Rank is numeric so
 * comparisons inside a plain suit are `>` with no lookup table.
 */
/** Canonical enumeration order. Used for deck ordering and stable UI ordering. */
export const SUITS = ['S', 'H', 'D', 'C'];
export const RANKS = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
const FACE_CACHE = new Map();
export function faceOf(id) {
    const hit = FACE_CACHE.get(id);
    if (hit)
        return hit;
    let face;
    if (id === 'JOKER') {
        face = { suit: null, rank: null };
    }
    else {
        const suit = id.slice(-1);
        const rank = Number(id.slice(0, -1));
        face = { suit, rank };
    }
    FACE_CACHE.set(id, face);
    return face;
}
export function cardId(rank, suit) {
    return `${rank}${suit}`;
}
export function suitOf(id) {
    return faceOf(id).suit;
}
export function rankOf(id) {
    return faceOf(id).rank;
}
export function colourOf(suit) {
    return suit === 'H' || suit === 'D' ? 'red' : 'black';
}
/** The other suit of the same colour. Used for left bowers and off-jacks. */
export function sameColourSuit(suit) {
    return { S: 'C', C: 'S', H: 'D', D: 'H' }[suit];
}
/** Display helpers. The client owns presentation, but replay/log text needs these. */
export const RANK_LABEL = {
    2: '2', 3: '3', 4: '4', 5: '5', 6: '6', 7: '7', 8: '8', 9: '9',
    10: '10', 11: 'J', 12: 'Q', 13: 'K', 14: 'A',
};
export const SUIT_LABEL = { S: '♠', H: '♥', D: '♦', C: '♣' };
export function cardLabel(id) {
    if (id === 'JOKER')
        return 'Joker';
    const { rank, suit } = faceOf(id);
    return `${RANK_LABEL[rank]}${SUIT_LABEL[suit]}`;
}
//# sourceMappingURL=cards.js.map